import { useState } from "react";
import { ProjectShowbox } from "../components/ProjectShowbox";
import StackList from "../components/StackList";
import useFetchResumeInfo from "../hooks/FetchResumeInfo";
import useFetchTechIcon from "../hooks/FetchTechIcon";

const ActionButton = (props) => {
  const { getIcon } = useFetchTechIcon();
  const { icon, name, isVisible, link } = props.data;

  return (
    isVisible && (
      <button
        // onClick={() => setActive(idx)}
        className="flex flex-row text-sm px-3 py-1 border rounded w-full dark:border-zinc-800"
        onClick={() => {
          !link
            ? alert(
                "The content for this link is currently under development and will be available soon. I am actively working on it.",
              )
            : window.open(link);
        }}
      >
        <div className="flex flex-col justify-center items-center mr-2">
          {getIcon(icon)}
        </div>
        <div className="flex flex-col justify-center items-center text-center w-full">
          {name}
        </div>
      </button>
    )
  );
};

const Projects = () => {
  const [active, setActive] = useState(null);
  const { resume, loading } = useFetchResumeInfo();
  const { getIcon } = useFetchTechIcon();

  return (
    <main className="max-w-6xl mx-auto px-6 py-12">
      {!loading && (
        <>
          <h2 className="text-2xl font-semibold">Projects</h2>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-3">
            {resume.projects.map((p, idx) => (
              <div
                key={p.title}
                className="flex flex-col border rounded bg-white dark:border-zinc-800"
              >
                <div className="flex flex-row border-b dark:bg-zinc-950">
                  <div className="flex flex-col justify-center items-center m-4">
                    {getIcon("project")}
                  </div>
                  <div className="py-3 pr-3 md:py-[15px] md:pr-[15px]">
                    <h3 className="font-semibold">{p.title}</h3>
                  </div>
                </div>
                <ProjectShowbox
                  data={{
                    imgsrc: p.imgSrc || "logo192.png",
                    sourceLink: p.source,
                    liveLink: p.live,
                    // demoLink: "",
                    width: 200,
                  }}
                />
                <div className="flex flex-col p-3 dark:bg-zinc-950 h-full">
                  <div className="flex flex-row justify-between items-start gap-3">
                    <ActionButton
                      data={{
                        icon: "GitHub",
                        name: "Source",
                        isVisible: true,
                        link: p.source,
                      }}
                    />
                    <ActionButton
                      data={{
                        icon: "internet",
                        name: "Live",
                        isVisible: true,
                        link: p.live,
                      }}
                    />
                    <ActionButton
                      data={{
                        icon: "youtube",
                        name: "Demo",
                        isVisible: true,
                        link: p.youtube,
                      }}
                    />
                  </div>

                  <div className="mt-5">
                    <StackList
                      data={{
                        stacks: p.stack,
                      }}
                    />
                  </div>

                  <p className="mt-5  text-sm">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {active !== null && (
            <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-50">
              <div className="bg-white max-w-3xl w-full rounded p-6">
                <div className="flex justify-between items-center">
                  <h3 className="font-semibold text-lg">
                    {resume.projects[active].title}
                  </h3>
                  <button className="text-sm" onClick={() => setActive(null)}>
                    Close
                  </button>
                </div>
                <div className="mt-4 ">
                  <p>{resume.projects[active].desc}</p>
                  <div className="mt-3 text-sm ">
                    Stack: {resume.projects[active].stack}
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </main>
  );
};

export default Projects;
